import "./styles.css";

// Force-emit the social/OG share image so its absolute URL is stable in dist/
import "./assets/logoOpaqueHighRes.jpeg";

// ─── Mobile nav toggle ───
const navToggle = document.getElementById("nav-toggle");
const navLinks = document.getElementById("nav-links");

navToggle.addEventListener("click", () => {
  const isOpen = navLinks.classList.toggle("nav__links--open");
  navToggle.classList.toggle("nav__hamburger--open", isOpen);
  navToggle.setAttribute("aria-expanded", isOpen);
});

// Close mobile nav on link click
navLinks.querySelectorAll(".nav__link").forEach((link) => {
  link.addEventListener("click", () => {
    navLinks.classList.remove("nav__links--open");
    navToggle.classList.remove("nav__hamburger--open");
    navToggle.setAttribute("aria-expanded", "false");
  });
});

// ─── Sticky nav border on scroll ───
const nav = document.getElementById("nav");

const handleScroll = () => {
  nav.classList.toggle("nav--scrolled", window.scrollY > 10);
};

window.addEventListener("scroll", handleScroll, { passive: true });
handleScroll();

// ─── Smooth scroll for anchor links ───
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", (e) => {
    const targetId = anchor.getAttribute("href");
    if (targetId === "#") return;

    const target = document.querySelector(targetId);
    if (!target) return;

    e.preventDefault();
    const navHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        "--nav-height",
      ),
    );
    const top = target.getBoundingClientRect().top + window.scrollY - navHeight;

    window.scrollTo({ top, behavior: "smooth" });

    // Update URL without triggering scroll
    history.pushState(null, null, targetId);
  });
});

// ─── Get Pro modal ───
const getProTriggers = document.querySelectorAll("#get-pro-btn, .js-get-pro");
const getProModal = document.getElementById("get-pro-modal");

if (
  getProTriggers.length &&
  getProModal &&
  typeof getProModal.showModal === "function"
) {
  const closeModal = () => getProModal.close();

  getProTriggers.forEach((btn) =>
    btn.addEventListener("click", () => getProModal.showModal()),
  );
  document
    .getElementById("get-pro-close")
    ?.addEventListener("click", closeModal);
  document
    .getElementById("get-pro-cancel")
    ?.addEventListener("click", closeModal);
  // Let the Web Store link navigate (new tab), then dismiss the modal.
  document
    .getElementById("get-pro-continue")
    ?.addEventListener("click", closeModal);
  // Click on the backdrop (outside the card) closes the modal.
  getProModal.addEventListener("click", (e) => {
    if (e.target === getProModal) closeModal();
  });
}

// ─── Scroll reveal animations ───
const revealElements = document.querySelectorAll(
  ".section__header, .step, .feature-card, .use-case-card, .tech__item, .voice__content, .voice__visual, .price-card, .roadmap__item, .faq__item, .cta__inner",
);

revealElements.forEach((el) => el.classList.add("reveal"));

if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("reveal--visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: "0px 0px -40px 0px" },
  );

  revealElements.forEach((el) => observer.observe(el));
} else {
  revealElements.forEach((el) => el.classList.add("reveal--visible"));
}
